import React from 'react';
import { Typography } from '@mui/material';

const TermsOfUseContent = () => (
    <>
    <Typography variant="h6" gutterBottom>Terms of Use & Liability Disclaimer</Typography>
    <Typography variant="body2" paragraph><strong>Effective Date:</strong> 06/05/2025</Typography>

    <Typography paragraph><strong>1. Acceptance of Terms</strong><br />
    By using Deeper (the “App”), you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree, do not use the App.</Typography>

    <Typography paragraph><strong>2. Eligibility</strong><br />
    You must be at least 18 years of age to use this App. By accessing the App, you affirm that you are 18 years or older.</Typography>

    <Typography paragraph><strong>3. Description of Service</strong><br />
    Deeper is a digital drinking and intimacy game for adult couples. It provides randomized prompts and challenges involving drinking, intimate acts, and personal conversations.</Typography>

    <Typography paragraph><strong>4. Entertainment Purposes Only</strong><br />
    This App is intended strictly for entertainment among consenting adults. The developers of Deeper are not licensed therapists, counselors, or health professionals.</Typography>

    <Typography paragraph><strong>5. Health & Safety Warning</strong><br />
    Drinking alcohol carries risks. Please drink responsibly.<br />
    Only engage in prompts or actions that you and your partner consent to and are comfortable with.<br />
    If any prompt or activity feels unsafe, inappropriate, or uncomfortable, you are encouraged to skip it.<br />
    Do not use the App if under the influence of alcohol or other substances to a degree that impairs your judgment or ability to consent.</Typography>

    <Typography paragraph><strong>6. No Liability</strong><br />
    You agree to use the App at your own risk. To the maximum extent permitted by law, Deeper and its developers disclaim all liability for:<br />
    - Physical or emotional harm<br />
    - Discomfort or distress<br />
    - Damaged relationships<br />
    - Consequences of drinking or intimacy-related actions<br />
    You release Deeper and its creators from any and all claims arising from your use of the App.</Typography>

    <Typography paragraph><strong>7. User Conduct</strong><br />
    You agree not to:<br />
    - Use the App in any unlawful manner<br />
    - Violate any partner's consent<br />
    - Share or distribute any content or screenshots without the other party’s permission</Typography>

    <Typography paragraph><strong>8. Data & Privacy</strong><br />
    Refer to our Privacy Policy for details on data collection and usage.</Typography>

    <Typography paragraph><strong>9. Modifications</strong><br />
    We reserve the right to change these terms at any time. Continued use constitutes acceptance of updated terms.</Typography>

    <Typography paragraph><strong>10. Governing Law</strong><br />
    These Terms are governed by the laws of Israel, without regard to conflict of law principles.</Typography>

    <Typography paragraph><strong>11. Intellectual Property</strong><br />
    All content, features, and functionality of Deeper— including but not limited to text, graphics, logos, and code— are the intellectual property of Deeper or its licensors and are protected by copyright and other intellectual property laws. You may not copy, modify, distribute, or exploit any part of the App without express written permission.</Typography>

    <Typography paragraph><strong>12. Prohibited Use</strong><br />
    You agree not to use the App to:<br />
    - Harass, abuse, or harm another person<br />
    - Record or share explicit content generated during use<br />
    - Violate any local, state, national, or international law<br />
    - Attempt to reverse-engineer or tamper with the App’s code or security features</Typography>

    <Typography paragraph><strong>13. Consent & Boundaries</strong><br />
    You and your partner are solely responsible for establishing and respecting mutual boundaries before and during the use of the App. The App cannot and does not verify or monitor consent. If consent is not fully present, discontinue use immediately.</Typography>

    <Typography paragraph><strong>14. Account Termination / Suspension</strong><br />
    We reserve the right to suspend or terminate access to the App at any time, without notice, for any conduct that violates these Terms or is deemed harmful to other users or the integrity of the App.</Typography>

    <Typography paragraph><strong>15. Payments & Refund Policy</strong><br />
    Payments made via Deeper, whether labeled as donations or purchases, are final. By making a payment, you agree that:<br />
    - All donations are non-refundable, including cases of accidental entry or change of mind.<br />
    - If payments are made in exchange for access to features or content, you are not entitled to a refund unless required by applicable law or explicitly stated otherwise.<br />
    - Refund requests may be considered only in cases of unauthorized or fraudulent transactions, and must be submitted within 14 days to deeper@deepergm.com.
    </Typography>

    <Typography paragraph><strong>16. No Guarantee of Availability or Compensation</strong><br />
    Deeper is provided "as is" and "as available." We may modify, suspend, or discontinue the App at any time, with or without notice, and without obligation to you. You acknowledge and agree that we are not liable for any losses or damages resulting from the unavailability or termination of the App, and no compensation or refund will be provided under any circumstances.</Typography>

    <Typography paragraph><strong>17. Contact Information</strong><br />
    For questions or concerns regarding these Terms, please contact us at deeper@deepergm.com.</Typography>
  </>
);

export default TermsOfUseContent;
